import { CloudPercentOutlineIcon } from './CloudPercentOutlineIcon';

/**
 * author: Simran
 * id CB1A76AC-F998-48D8-A4DC-C29CD02CDFF7
 * name cloud-percent-outline
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cloud-percent-outline.svg
 * tags
 * - Weather 
 * - Cloud 
 * - Nature 
 */
export const RainChanceOutlineIcon = CloudPercentOutlineIcon;
export default RainChanceOutlineIcon